(function () {
  if (window.__OCSkuSearchAlias) return;
  window.__OCSkuSearchAlias = true;

  function normalizeQuery(q) {
    if (!q) return q;
    var t = String(q).trim();
    if (!t) return t;

    // OCxxxx -> ALLxxxx (неважно какой регистр у OC)
    if (/^OC/i.test(t)) return 'ALL' + t.slice(2);

    return t;
  }

  function isSearchForm(form) {
    if (!form || !form.action) return false;

    try {
      var u = new URL(form.action, window.location.origin);
      return /\/search\/?$/.test(u.pathname);
    } catch (e) {
      var a = form.getAttribute('action') || '';
      return a.indexOf('/search') !== -1;
    }
  }

  function bindSearchForm(form) {
    if (!isSearchForm(form) || form.dataset.ocAliasBound) return;
    form.dataset.ocAliasBound = '1';

    form.addEventListener(
      'submit',
      function () {
        var input = form.querySelector('input[name="q"]');
        if (!input) return;

        var original = (input.value || '').trim();
        var normalized = normalizeQuery(original);
        if (!normalized || normalized === original) return;

        // Чтобы Shopify искал по ALL..., но пользователь видел OC...
        // 1) переименуем видимый input
        input.name = 'ocq_display';

        // 2) добавим скрытый q=ALL...
        var hiddenQ = document.createElement('input');
        hiddenQ.type = 'hidden';
        hiddenQ.name = 'q';
        hiddenQ.value = normalized;
        form.appendChild(hiddenQ);

        // 3) сохраним оригинал в ocq=OC... (чтобы потом показать на странице результатов)
        var hiddenOrig = document.createElement('input');
        hiddenOrig.type = 'hidden';
        hiddenOrig.name = 'ocq';
        hiddenOrig.value = original;
        form.appendChild(hiddenOrig);
      },
      true
    );
  }

  function bindAllForms() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) bindSearchForm(forms[i]);
  }

  function applyDisplayQueryFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var ocq = params.get('ocq');
      if (!ocq) return;

      // На странице результатов поиска покажем пользователю OC..., даже если искали по ALL...
      var forms = document.querySelectorAll('form[action*="/search"]');
      for (var f = 0; f < forms.length; f++) {
        var qInput = forms[f].querySelector('input[type="search"], input[name="q"]');
        if (qInput) qInput.value = ocq;
      }
    } catch (e) {}
  }

  function rewriteSuggestUrl(urlString) {
    try {
      var u = new URL(urlString, window.location.origin);

      // Dawn predictive search дергает /search/suggest (и иногда .json)
      if (u.pathname.indexOf('/search/suggest') === -1) return urlString;

      var q = u.searchParams.get('q');
      var nq = normalizeQuery(q);
      if (nq && nq !== q) u.searchParams.set('q', nq);

      return u.toString();
    } catch (e) {
      return urlString;
    }
  }

  // Подмена запросов predictive search (подсказки) без изменения текста в инпуте
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (resource, init) {
      try {
        var url = null;
        var req = null;

        if (typeof resource === 'string') {
          url = resource;
        } else if (resource && typeof resource.url === 'string') {
          url = resource.url;
          req = resource;
        }

        if (url) {
          var newUrl = rewriteSuggestUrl(url);
          if (newUrl !== url) {
            if (req) resource = new Request(newUrl, req);
            else resource = newUrl;
          }
        }
      } catch (e) {}

      return _fetch(resource, init);
    };
  }

  function init() {
    bindAllForms();
    applyDisplayQueryFromUrl();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Dawn может динамически перерисовывать хедер/модалки — подцепимся заново
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      bindAllForms();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();




// PDP accordio + tabs

document.addEventListener('DOMContentLoaded', function () {
  // Аккордеон: открытие/закрытие
  document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.accordion-item');
      const content = item.querySelector('.accordion-content');

      item.classList.toggle('open');

      if (item.classList.contains('open')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = null;
      }
    });
  });

  // Переключение вкладок
  document.querySelectorAll('.tab-button').forEach(button => {
    button.addEventListener('click', () => {
      const tabId = button.dataset.tab;
      const container = button.closest('.tabs-container');

      container.querySelectorAll('.tab-button').forEach(btn => btn.classList.remove('active'));
      container.querySelectorAll('.tab-panel').forEach(panel => panel.classList.remove('active'));

      button.classList.add('active');
      container.querySelector('#' + tabId).classList.add('active');

      // Обновляем maxHeight аккордеона для корректного отображения
      const accordionContent = button.closest('.accordion-content');
      if (accordionContent) {
        accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
      }
    });
  });

  // Автоматическое обновление высоты аккордеона при изменении контента
  const allAccordionContents = document.querySelectorAll('.accordion-content');
  allAccordionContents.forEach(content => {
    const observer = new ResizeObserver(() => {
      const parentItem = content.closest('.accordion-item');
      if (parentItem.classList.contains('open')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
    observer.observe(content);
  });

  // ✅ Устанавливаем max-height для уже открытых аккордеонов при загрузке
  document.querySelectorAll('.accordion-item.open .accordion-content').forEach(content => {
    content.style.maxHeight = content.scrollHeight + 'px';
  });
});
